/*
 * @Author: linwl 1015547748@qq.com
 * @Date: 2025-10-14 15:46:24
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2025-11-13 15:06:18
 * @FilePath: \mall\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import priceConvet from '@/components/PriceConvert/index.vue'
import sIcon from '@/components/SIcon/index.vue'
import isWeChatWeb from '@/utils/checkWebUserAgent'
// import plugins from '@/utils/globleComponents';
import '@/utils/rem.js'
import setInfoDecimal from '@/utils/setInfoDecimal'
import '@/utils/svgIcon.js'
// 图标管理器已在svgIcon.js中引入，这里不需要再次引入
// import '@/utils/iconManager.js'
import Vant, { Toast } from 'vant'
import 'vant/lib/index.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/styles/basis.scss'
// 设置全局颜色（默认兜底 + 后台主题接口动态覆盖）
import { fetchAndApplyTheme } from '@/utils/setGlobalColor'

import './utils/checkWebUserAgent'
import './utils/VConsole'
// 设置微信小程序script
import './utils/setMapScript'
import './config/color.config'
import './libs/versionUpdate'

// coze客服
// import './libs/coze'

// 全局添加 ¥计算函数
Vue.prototype.$setInfoDecimal = setInfoDecimal
Vue.prototype.$toast = Toast
// 判断是否微信浏览器
Vue.prototype.$isWeChatWeb = isWeChatWeb

Vue.use(Vant)

Vue.component('s-icon', sIcon)
Vue.component('price-convert', priceConvet)

Vue.config.productionTip = false

// 全局点击防抖处理
Vue.directive('debounce-click', {
  bind(el, binding) {
    const debouncedFn = debounce(binding.value, 300)
    el.addEventListener('click', debouncedFn)
    el._debouncedFn = debouncedFn
  },
  unbind(el) {
    if (el._debouncedFn) {
      el.removeEventListener('click', el._debouncedFn)
      delete el._debouncedFn
    }
  }
})

// 启动时拉取后台激活主题并应用全局主题色（失败静默回退默认兜底色）
fetchAndApplyTheme()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
